import {Component, OnInit} from '@angular/core';
import {IMyDateModel} from 'mydatepicker';
import {ActionsService} from './actions.service';

@Component({
    selector: 'actions',
    templateUrl: './templates/actions.component.html',
    styleUrls: ['./styles/actions.component.css'],
    providers: [ActionsService]
})
export class ActionsComponent implements OnInit {

    list_actions: Array<any> = [];

    code: any = '';
    user: any = '';
    date: any = '';
    history: any;
    constructor(
        private actions_service: ActionsService
    ) {}

    ngOnInit() {
        this.getAllActions();
    }

    getAllActions(): void {
        this.actions_service.getAllActions(this.code, this.user, this.date)
            .then(result => {
                this.list_actions = result['list_actions'];
            });
    }

    onDateChanged(event: IMyDateModel) {
        if (event.jsdate === null) {
            this.date = "";
        } else {
            this.date = event.jsdate.toLocaleDateString("en-US");
        }
        this.getAllActions();
    }

    viewDetails(id_action_user: any) {
        this.actions_service.getDetailsActions(id_action_user)
            .then(result => {
                this.history = result['action'];
            });
    }

}



// WEBPACK FOOTER //
// ./src/app/actions.component.ts